const MapSection = () => {
  return (
    <section className="py-16 sm:py-20 md:py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 font-['Poppins']">
            Serving Dallas-Fort Worth
          </h2>
          <p className="text-base sm:text-lg text-gray-600 px-4">
            Proudly serving homeowners throughout the DFW metroplex
          </p>
        </div>

        <div className="rounded-2xl overflow-hidden shadow-xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d429156.68834230375!2d-97.32064844999999!3d32.7766642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c19f77b45974b%3A0xb9ec9ba4f647678f!2sDallas-Fort%20Worth%2C%20TX!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Dallas-Fort Worth Service Area"
            className="sm:h-[500px]"
          ></iframe>
        </div>

        <div className="mt-8 sm:mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 text-center">
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md">
            <i className="ri-map-pin-line text-3xl sm:text-4xl text-teal-500 mb-3"></i>
            <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg">Service Area</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              Dallas, Fort Worth, Arlington, Plano, Irving, Frisco, McKinney, and surrounding areas
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md">
            <i className="ri-car-line text-3xl sm:text-4xl text-teal-500 mb-3"></i>
            <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg">Free Estimates</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              Virtual estimates available throughout DFW with no travel fees or hidden charges
            </p>
          </div>
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md sm:col-span-2 lg:col-span-1">
            <i className="ri-customer-service-2-line text-3xl sm:text-4xl text-teal-500 mb-3"></i>
            <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg">Local Support</h3>
            <p className="text-xs sm:text-sm text-gray-600">
              Family-owned business committed to serving our local community with excellence
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
